var exports = {
  "iE": "xfd349460--e01e5a--wrapper",
  "wx": "xfd349460--e01e5a--header",
  "Qs": "xfd349460--e01e5a--content",
  "nf": "xfd349460--e01e5a--link",
  "qr": "xfd349460--e01e5a--footer",
};

module.exports = exports;
